import apiClient from '../apiClient';
import { GET_PACKAGE_BY_TYPE_AND_ID_URL } from '../apiUrl';

const getReadyPackageByTypeAndIdApi = (Type, Id) => {
  return apiClient.get(GET_PACKAGE_BY_TYPE_AND_ID_URL(Type, Id));
};

export default getReadyPackageByTypeAndIdApi;
